<form class="form">
    <div #cardElement class="card" *ngIf="isEditing">
        <div class="btn_container"><button (click)="closeSelectedEditText()" type="button" class="btn_close"><span class="material-symbols-outlined fz_l">
                close
            </span></button></div>
        <div class="color_green fz_xs">Текст для редактирования</div>
        <div class="row row_ai_center"><span class="material-symbols-outlined">
            edit_note
        </span>
        <p class="selected_edit_text fz_xs write_srace_nowrap">{{note.text}}</p>
        </div>
    </div>
    <div class="textarea_container">
        <textarea placeholder="Введите текст и нажмите &crarr;" (input)="writeText($event)"
            (keydown)="handleKeyDown($event)" [(ngModel)]="noteText" class="textarea color_input transition"
            name="comment">
        </textarea>

        <button *ngIf="!isEditing && noteText" (click)="createNote()" class="btn row"
            type="button"> <span class="material-symbols-outlined fz_title">add</span>
        </button>
        
        <button *ngIf="isEditing" (click)="updateNote()" class="btn row" type="button">
            <span class="material-symbols-outlined fz_title">edit_square</span>
        </button>
    </div>
</form>